import { useContext, useEffect, useState } from "react";
import CRUDTabTableModal from "../../components/CRUDTabTableModal";
import LockedModuleTooltip from "../../components/LockedModuleTooltip";
import OperationConfigModal from "../../components/Modal/OperationConfigModal";
import TaskConfiguration from "../../components/TaskConfiguration";
import useCheckModule from "../../hooks/useCheckModule";
import usePermission from "../../hooks/usePermission";
import { getMultiAssetProgrammeTemplate } from "../../services/api-server/multi_asset_programme_template";
import { getWells } from "../../services/api-server/wells";
import Emitter from "../../utils/emitter";
import { HomeContext } from "../Home";

const ProjectOutline = (props: any) => {
	const context: any = useContext(HomeContext);

	const [otherData, setOtherData] = useState<any>(null);
	const [operationModalOpen, setOperationModalOpen] = useState<boolean>(false);
	const [operationRecord, setOperationRecord] = useState<any>(null);
	const [wellList, setWellList] = useState<any>(null);
	const [userPermissions, setUserPermissions] = useState<string[] | null>(null);
	const [operationTemplate, setOperationTemplate] = useState<any>(null);

	const hasCreateWellPermission = usePermission(
		"Create.Well",
		props?.currentProject
	);
	const hasCreateOperationPermission = usePermission(
		"Create.Operation",
		props?.currentProject
	);

	const { checkModule } = useCheckModule();

	useEffect(() => {
		setOtherData({
			project_code: props.currentProject,
			_id: props.currentProjectData._id,
		});

		getWells(context.currentTenantKey, {
			project_ids: { $ne: props.currentProjectData._id },
		})
			.then((data: any) => {
				setWellList(data);
			})
			.catch((err) => {
				console.log(err);
			});

		getMultiAssetProgrammeTemplate(context.currentTenantKey, {
			_id: props.currentProjectData.project_template ?? null,
		})
			.then((data: any) => {
				setOperationTemplate(data[0].operations ?? null);
			})
			.catch((err) => {
				console.log(err);
			});
	}, [props.currentProject]);

	useEffect(() => {
		const handleOperationModal = (data: any) => {
			setOperationModalOpen(true);
			setOperationRecord(data);
			console.log("operationRecord", operationRecord);
		};

		// Subscribes to `operationModalOpen` event, which executes `handleOperationModal` when event is triggered
		Emitter.on("operationModalOpen", handleOperationModal);
		return () => {
			// Cleans up the event listener when the component unmounts to prevent memory leaks
			Emitter.off("operationModalOpen", handleOperationModal);
		};
	}, []);

	useEffect(() => {
		if (props.navTabKey === "project-outline") {
			Emitter.emit("taskModalOpen", {
				...props.navTabPayload,
			});
		}
	}, [props.navTabKey]);

	useEffect(() => {
		const permissions = [
			"update",
			"add",
			"add-existing_well",
			"delete",
			...(hasCreateWellPermission.hasPermission ? ["add-well"] : []),
			...(hasCreateOperationPermission.hasPermission
				? ["add-operations", "add-phase"]
				: []),
		];
		setUserPermissions(permissions);
	}, [hasCreateWellPermission, hasCreateOperationPermission]);

	return (
		<>
			{props.currentProject !== null && context?.allData && otherData && (
				<CRUDTabTableModal
					items={[
						...(props.currentProjectData?.project_scope === "multi-asset"
							? [
									{
										label: checkModule("project-delivered") ? (
											"Project framework"
										) : (
											<LockedModuleTooltip>
												<div style={{ marginRight: "20px" }}>
													Project framework
												</div>
											</LockedModuleTooltip>
										),
										key: "phase",
										directoryName: "Phases and tasks directory",
										formOption: "multi-asset",
										sortKey: "sequence_id",
										disabled: !checkModule("project-delivered"),
									},
								]
							: []),
						{
							label: "Well management",
							key: "well_operation",
							directoryName: "Well directory",
							// addItemPrivilege: ["tenant-admin", "project-admin"],
						},
					]}
					tabKey={"project-outline"}
					otherData={otherData}
					headerName={"Project outline"}
					reorderModal
					user={props?.user}
					userPermissions={userPermissions}
				/>
			)}
			{operationModalOpen && (
				<OperationConfigModal
					open={operationModalOpen}
					setOpen={setOperationModalOpen}
					setOperationRecord={setOperationRecord}
					operationRecord={operationRecord}
					extraData={{ ...context.allData, operationTemplate }}
					user={props?.user}
					userRole={props?.userRole}
					currentProjectData={props.currentProjectData}
				/>
			)}
			<TaskConfiguration
				projectData={props.currentProjectData}
				setOtherData={setOtherData}
			/>
		</>
	);
};

export default ProjectOutline;
